// Generated by Melange

import * as Curry from "melange.js/curry.jsx";
import * as Stdlib from "melange/stdlib.jsx";

function ask(param) {
  return {
    TAG: /* Sync */ 2,
    _0: (function (value) {
      return {
        TAG: /* Ok */ 0,
        _0: value
      };
    })
  };
}

function provide(fx, deps) {
  switch (fx.TAG) {
    case /* Ok */ 0 :
      return {
        TAG: /* Ok */ 0,
        _0: fx._0
      };
    case /* Error */ 1 :
      return {
        TAG: /* Error */ 1,
        _0: fx._0
      };
    case /* Sync */ 2 :
      const f = fx._0;
      return {
        TAG: /* Sync */ 2,
        _0: (function (param) {
          return provide(Curry._1(f, deps), deps);
        })
      };
    case /* Async */ 3 :
      const f$1 = fx._0;
      return {
        TAG: /* Async */ 3,
        _0: (function (param) {
          return Curry._1(f$1, deps).then(function (fx) {
            return Promise.resolve(provide(fx, deps));
          });
        })
      };
  }
}

function bind(fx, cb) {
  switch (fx.TAG) {
    case /* Ok */ 0 :
      return Curry._1(cb, fx._0);
    case /* Error */ 1 :
      return {
        TAG: /* Error */ 1,
        _0: fx._0
      };
    case /* Sync */ 2 :
      const f = fx._0;
      return {
        TAG: /* Sync */ 2,
        _0: (function (deps) {
          return bind(Curry._1(f, deps), cb);
        })
      };
    case /* Async */ 3 :
      const f$1 = fx._0;
      return {
        TAG: /* Async */ 3,
        _0: (function (deps) {
          return Curry._1(f$1, deps).then(function (result) {
            return Promise.resolve(bind(result, cb));
          });
        })
      };
  }
}

function $$catch(fx, cb) {
  switch (fx.TAG) {
    case /* Ok */ 0 :
      return {
        TAG: /* Ok */ 0,
        _0: fx._0
      };
    case /* Error */ 1 :
      return Curry._1(cb, fx._0);
    case /* Sync */ 2 :
      const f = fx._0;
      return {
        TAG: /* Sync */ 2,
        _0: (function (deps) {
          return $$catch(Curry._1(f, deps), cb);
        })
      };
    case /* Async */ 3 :
      const f$1 = fx._0;
      return {
        TAG: /* Async */ 3,
        _0: (function (deps) {
          return Curry._1(f$1, deps).then(function (result) {
            return Promise.resolve($$catch(result, cb));
          });
        })
      };
  }
}

function map(fx, f) {
  return bind(fx, (function (value) {
    return {
      TAG: /* Ok */ 0,
      _0: Curry._1(f, value)
    };
  }));
}

function run(_fx, deps) {
  while (true) {
    const fx = _fx;
    switch (fx.TAG) {
      case /* Ok */ 0 :
        return {
          TAG: /* Ok */ 0,
          _0: fx._0
        };
      case /* Error */ 1 :
        return {
          TAG: /* Error */ 1,
          _0: fx._0
        };
      case /* Sync */ 2 :
        _fx = Curry._1(fx._0, deps);
        continue;
      case /* Async */ 3 :
        return Stdlib.failwith("Cannot run async fx synchronously");
    }
  };
}

function runAsync(_fx, deps) {
  while (true) {
    const fx = _fx;
    switch (fx.TAG) {
      case /* Ok */ 0 :
        return Promise.resolve({
          TAG: /* Ok */ 0,
          _0: fx._0
        });
      case /* Error */ 1 :
        return Promise.resolve({
          TAG: /* Error */ 1,
          _0: fx._0
        });
      case /* Sync */ 2 :
        _fx = Curry._1(fx._0, deps);
        continue;
      case /* Async */ 3 :
        return Curry._1(fx._0, deps).then(function (fx) {
          return runAsync(fx, deps);
        });
    }
  };
}

const Monad_syntax = {
  let$star: bind
};

export {
  ask,
  provide,
  bind,
  $$catch,
  map,
  run,
  runAsync,
  Monad_syntax,
}
/* No side effect */
